import React from "react";
import "./footer.css";
import "../header/header.css";
import { useTranslation } from "react-i18next";
import BtnOrder from "./../buttons/order/BtnOrder";

const EMAIL = process.env.REACT_APP_EMAIL;
const GMAIL = process.env.REACT_APP_GMAIL;
const PHONE = process.env.REACT_APP_PHONE;
const ADDRESS = process.env.REACT_APP_ADDRESS;

export default function Footer() {
    const { t } = useTranslation();
    const emailData = "mailto:" + EMAIL + "?subject=" + t("header_email");
    const gmailData = "mailto:" + GMAIL + "?subject=" + t("header_email");

    return (
        <div className="footer">
            <div className="footer__container">
                <div className="footer__top">
                    <div className="footer__title">
                        <div className="footer__title__text">
                            <h3>{t("footer_title")}</h3>
                        </div>
                        <BtnOrder name={t("footer_btn")} />
                    </div>
                </div>
                <div className="footer__content">
                    <div className="footer__info">
                        <p>
                            {t("footer_address")}
                            {"\u00A0"}
                            <span> {ADDRESS}</span>
                        </p>
                        <p>
                            {t("footer_phone")} {"\u00A0"}{" "}
                            <span> +{PHONE}</span>
                        </p>
                        <p>
                            Email: {"\u00A0"}{" "}
                            <a href={emailData}>
                                <span> info.gesandger@sezman.cz</span>
                            </a>
                        </p>
                        <p>
                            Gmail: {"\u00A0"}{" "}
                            <a href={gmailData}>
                                <span>gesandger@gmail.com</span>
                            </a>
                        </p>
                    </div>
                </div>
                <div className="footer__bottom">
                    <p>
                        &copy; {new Date().getFullYear()}
                        {"\u00A0"}
                        {t("footer_copy")}
                    </p>
                </div>
            </div>
        </div>
    );
}
